import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import QuienSoy from "@/components/QuienSoy";
import Especialidades from "@/components/Especialidades";
import ProtocoloPuntoCero from "@/components/ProtocoloPuntoCero";
import PorQue from "@/components/PorQue";
import Galeria from "@/components/Galeria";
import Aseguradoras from "@/components/Aseguradoras";
import Financiamiento from "@/components/Financiamiento";
import Contacto from "@/components/Contacto";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

const Home = () => {
    return (
        <main data-testid="home-page" className="bg-cream text-ink antialiased">
            <Navbar />
            <Hero />
            <QuienSoy />
            <Especialidades />
            <ProtocoloPuntoCero />
            <PorQue />
            <Galeria />
            <Aseguradoras />
            <Financiamiento />
            <Contacto />
            <Footer />
            <WhatsAppButton />
        </main>
    );
};

function App() {
    return (
        <div className="App">
            <Toaster
                position="top-center"
                richColors
                toastOptions={{
                    style: {
                        background: "#0D1F4E",
                        color: "#F8F6F1",
                        border: "1px solid rgba(201,168,76,0.3)",
                        borderRadius: 0,
                        fontFamily: "Manrope, system-ui, sans-serif",
                    },
                }}
            />
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Home />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
